export default defineI18nLocale(() => {
  return {
    home: {
      openFinance: 'Açık Finans',
      description:
        'Kurumsal likidite ile güvenli, hızlı, gaz ücreti olmayan zincir üstü işlem',
      gasFees: 'Gaz Ücretleri',
      whyHelix: 'Neden Helix?',
      reimagined: 'Yeniden Tasarlandı',
      latestNews: 'Son Haberler',
      totalVolume: 'Toplam Hacim',
      totalMarkets: 'Toplam Piyasalar',
      startTrading: 'İşlem Yapmaya Başla',
      helixDocs: 'Helix Dokümantasyonu',
      somethingIsBrewing: 'Bir Şeyler Oluyor',
      builtForTheCommunity: 'Topluluk İçin Tasarlandı',
      builtForTheCommunityDescription:
        'Yatırımcı yok, risk sermayesi yok, saçmalık yok.',
      downloadHelixMobile:
        'iOS veya Android için Helix Mobil uygulamasını indir',
      overview: {
        title: 'Neden Helix?',
        lpRewardsTitle: 'LP Ödülleri',
        tradingBotsTitle: 'Alım Satım Botları',
        gasFreeTitle: 'Gaz Ücreti Olmadan İşlem',
        tradeStocksTitle: 'Hisse Senetleri ve Gerçek Dünya Varlıklarıyla İşlem',
        lpRewardsDescription: 'Likidite sağlayın ve bunun için ödeme alın.',
        description:
          'Üst düzey bir borsa olarak inşa edildi, ancak tamamen merkeziyetsiz.',
        gasFreeDescription:
          "Helix'te gaz ücretlerini hiç dert etmeyin. Sıfır gaz, her zaman.",
        tradingBotsDescription:
          'Tek tıkla gelişmiş akıllı zincir üstü işlem stratejileri dağıtın.',
        tradeStocksDescription:
          'Hisse senetleri ve Gerçek Dünya Varlıkları (RWA) ile kripto kullanarak daha hızlı, daha ucuz ve daha şeffaf işlemler yapın.'
      },
      gettingStarted: {
        title: "Helix'te Başlarken",
        injectiveBridge: 'Injective Köprüsü',
        description: "Kripto varlıkları Injective'a yatırın ",
        description2:
          "USDT ve diğer varlıkları {bridgeLink} üzerinden Helix'e köprüleyin.",
        gasRequirement:
          'İşlem ücretini ödemek için en az 0.1 INJ aldığınızdan emin olun.',
        step1: {
          title: 'Adım 1',
          description:
            'Injective Köprüsünü ziyaret edin ve cüzdanınızı bağlayın.'
        },
        step2: {
          title: 'Adım 2',
          description:
            'Kaynak zinciri seçin (örneğin Ethereum, Cosmos veya Solana).'
        },
        step3: {
          title: 'Adım 3',
          description: 'USDT veya başka bir varlık seçin'
        },
        step4: {
          title: 'Adım 4',
          description:
            "İşlem tamamlandığında, Helix'e dönün ve Portföy sayfasında Bakiyelerinizi kontrol edin. İşlem yapmaya hazırsınız!"
        }
      },
      mobile: {
        usp1: 'Yeni Başlayanlar İçin Uygun',
        title: 'Cebinizden Perpetual İşlemler Yapın',
        usp2: 'Kripto, Hisseler, Emtialar ve Döviz',
        downloadHelixMobile: "Helix Mobil'i İndir"
      },
      faq: {
        title: 'Sıkça Sorulan Sorular',
        or: 'veya',
        on: 'üzerinde',
        and: 've',
        here: 'burada',
        fullstop: '.',
        accordion1: {
          title: 'Helix hangi özellikleri sunar?',
          featureTitle:
            'Helix, gelişmiş özellikler ve esneklikle sorunsuz ve güçlü bir ticaret deneyimi sunar:',
          stocks: 'hisseler',
          lpRewards: 'LP ödülleri',
          commodities: 'emtialar',
          spotMarkets: 'Spot Piyasalar',
          tradingBots: 'ticaret botları',
          autoSigning: 'otomatik imzalama',
          makerRebates: 'maker iadeleri',
          feeDiscounts: 'işlem ücreti indirimleri',
          oneHundredLeverage: '100x kaldıraç',
          perpetualMarkets: 'Perpetual Piyasalar',
          tradingCompetitions: 'ticaret yarışmaları',
          feature1: 'En iyi kripto paraları {spotMarkets} üzerinde alıp satın.',
          feature2:
            '{perpetualMarkets} üzerinde kripto, {stocks} ve altın, gümüş gibi {commodities} dahil olmak üzere {oneHundredLeverage} kaldıraç kullanın.',
          feature3:
            '{tradingBots} ile spot ve perpetual piyasalar için stratejilerinizi otomatikleştirin.',
          feature4:
            'INJ stake ederek {lpRewards}, {makerRebates} ve {feeDiscounts} kazanın.',
          feature5:
            '{autoSigning} ve gazsız bir deneyim ile akıcı bir ticaret sürecinden yararlanın.',
          feature6:
            'Sık sık düzenlenen {tradingCompetitions}’a katılın ve özel ödüllerin kilidini açın.'
        },
        accordion2: {
          title: 'Helix’e varlıkları nasıl getiririm?',
          optionTitle:
            "Helix'te işlem yapmaya başlamak için önce Injective ağı üzerinde USDT veya INJ gibi varlıklar edinmelisiniz:",
          fiatOnRamps: 'fiat giriş yöntemleri',
          injectiveBridge: 'Injective Köprüsü',
          option1:
            'Kriptoyu {fiatOnRamps} aracılığıyla (banka kartı/kredi kartı, Revolut, Apple Pay, Google Pay ve daha fazlası ile) satın alın.',
          option2:
            'Başka zincirlerden varlık yatırmak için {injectiveBridge} kullanın.',
          option3:
            'Alternatif olarak Binance, ByBit ve daha fazlası gibi merkezi borsalardan da yatırım yapabilirsiniz.'
        },
        accordion3: {
          title: 'Helix’te kripto para nasıl alım satımı yapılır?',
          stepTitle:
            'Helix üzerinde işlem yapmak hızlı, izinsiz ve tamamen gazsızdır. İşte nasıl başlayacağınız:',
          inj: 'INJ',
          spot: 'Spot',
          usdt: 'USDT',
          limit: 'limit',
          helix: 'helixapp.com',
          perpetual: 'Perpetual',
          marketOrder: 'piyasa emri',
          videoTutorialHere: 'video eğitimi burada',
          step1: '{helix} adresine gidin ve cüzdanınızı bağlayın.',
          step2: '{usdt} veya {inj} gibi varlıkları yatırın veya köprüleyin.',
          step3:
            'İşlem yapmak istediğiniz bir {spot} ya da {perpetual} piyasası seçin.',
          step4:
            'Yalnızca birkaç tıklamayla bir {limit} veya {marketOrder} emri verin.',
          cta: 'Tüm adımları görmek ister misiniz? Adım adım {tutorial} kılavuzumuza göz atın.'
        },
        accordion4: {
          title: 'Helix Mobil uygulaması var mı ve nereden indirebilirim?',
          appStore: 'iOS (App Store)',
          playStore: 'Android (Google Play)',
          description:
            'Helix Mobile, {appStore} ve {playStore} üzerinden ücretsizdir. Uygulamayı kurun, cüzdanınızı bağlayın ve web sürümünde gördüğünüz piyasa ve bakiyeleri burada da görün.'
        },
        accordion5: {
          title: 'Helix Mobil’de cüzdanımı nasıl bağlarım?',
          description: 'Üç seçeneğiniz var:',
          option1:
            "QR kodunu tarayın - Helix Mobile'ı açın, “Helix web üzerinde QR kodu tara”ya dokunun ve kameranızı Helix web uygulamasındaki ayarlarda gösterilen QR koduna doğrultun. (ACM'deki AuthZ modülüne bağlantı)",
          option2:
            'Mevcut sosyal girişinizi kullanın - masaüstünde kullandığınız aynı Google veya Apple hesabıyla giriş yapın, cüzdanınız anında görünür.',
          option3:
            'Yeni bir cüzdan oluşturun - sıfırdan başlamak isterseniz e-posta adresinize bağlı yeni bir saklama dışı cüzdan oluşturun.'
        },
        accordion6: {
          title: 'Helix Mobil varlıklarımı nasıl güvende tutuyor?',
          description:
            'Helix Mobil uygulaması tamamen gözetimsizdir. Özel anahtarlar cihazınızda kalır, işlemler yerel olarak imzalanır ve ayarlardan biyometrik iki faktörlü doğrulama ekleyebilirsiniz. Helix, fonlarınızı veya seed phrase’inizi asla tutmaz - güvenlik web sürümündekiyle birebir aynıdır. Sosyal girişler için anahtarlar, sektör standardı olan Turnkey tarafından güvenli bir şekilde saklanır.'
        }
      }
    },
    swap: {
      fees: 'Ücretler',
      rate: 'Oran',
      title: 'Swap',
      route: 'Rota',
      youPay: 'Ödediğiniz',
      youReceive: 'Aldığınız',
      backToSwap: 'Swapa Geri Dön',
      enterAmount: 'Miktar girin',
      maximumInput: 'Maksimum Giriş',
      tolerance: 'Slippage Toleransı',
      minimumOutput: 'Minimum çıktı',
      connectWallet: 'Cüzdanı Bağla',
      expectedOutput: 'Beklenen çıktı',
      viewTransaction: 'İşlemi Görüntüle',
      advancedSettings: 'Gelişmiş Ayarlar',
      currentlyOffline: 'Şu anda çevrimdışı',
      swapTime: 'Swap ({swapTimeRemaining}s)',
      somethingWentWrong: 'Bir şeyler ters gitti.',
      swappedSuccessfully: 'Swap başarılı!',
      rateExpired: 'Oran süresi doldu. Güncellemek için tıklayın',
      swapAmountTooLow: 'Swap miktarı çok düşük',
      insufficientLiquidity: 'Yetersiz Likidite',
      pleaseTryAgain: 'Tekrar denemek için sayfayı yenileyin.',
      tooltip:
        'Fiyat bu yüzdeyi aşan şekilde olumsuz değişirse işleminiz otomatik iptal edilir.',
      youHaveSwapped:
        '{inputAmount} {inputTokenSymbol} tokenini {outputAmount} {outputTokenSymbol} tokenine çevirdiniz',
      priceWarning:
        'Yüksek slippage tespit edildi! Beklenenden daha az {symbol} alabileceğinizi anladığınızda devam edin.'
    },
    guild: {
      title: 'Guildler',
      description:
        'Helix Guildler, takım bazlı bir işlem yarışmasıdır. Kazanan guildin parçası olun ve birlikte kazanın!',
      rewardDescription1:
        'Her guild için iki sıralama vardır. Birisi TIA/USDT piyasasında tüm guild üyelerinin oluşturduğu toplam işlem hacmine, diğeri ise tüm üyelerin ağırlıklı ortalama TIA bakiyesine göre yapılır. Her kategoride en yüksek sıralamaya sahip guild 500 INJ ve 5,000 TIA almaya hak kazanır.',
      rewardDescription2:
        'Her guild en fazla 150 üye tutabilir, katılabilmek için hemen birine katılın!',
      inactiveDescription:
        "Guild tarafından oluşturulan hacim, guild liderinin TIA bakiyesi {amount} TIA'nın üstünde olana kadar sayılmaz",
      inactiveTooltip: "Guild lideri TIA bakiyesi {amount} TIA'nın altında",
      you: 'Siz',
      guilds: 'Guildler',
      noData: 'Veri yok',
      endsIn: 'Sona eriyor',
      rewards: 'Ödüller',
      readyIn: 'Hazır olma süresi',
      startsIn: 'Başlıyor',
      seasonEnded: 'Sezon sona erdi',
      startOn: '{date} tarihinde başlar',
      participants: 'Katılımcılar',
      totalRewards: 'Toplam ödüller',
      showInactive: 'Pasif olanları göster',
      currentSeason: 'Mevcut sezon',
      campaignRules: 'Kampanya kuralları',
      seasonOneEnded: '1. Sezon sona erdi',
      howToParticipate: {
        title: 'Nasıl katılırım',
        createGuild: {
          cta: 'Guild oluştur',
          title: 'Guild lideri olun ve başkalarını davet edin',
          description:
            "Yarışma boyunca cüzdanınızda en az {amount} TIA bulundurun. Guildiniz kazanırsa ödüllerin %20'sini kazanın!"
        },
        joinGuild: {
          cta: 'Injective Discord’una Git',
          title: 'Bir guild’e katıl ve arkadaşlarınla kazan',
          description:
            'Daha fazla TIA ve işlem hacmi ile sıralamada yüksel. Eğer guild’in kazanırsa ödüllerin %80’ini arkadaşlarınla paylaş!',
          description2:
            '#helix-guilds Discord kanalında bir guild bul ya da arkadaşlarından davet kodu iste!'
        }
      },
      leaderboard: {
        title: 'Liderlik Tabloları',
        guildMembers: 'Guild üyeleri',
        fetchNewData: 'Verileri yenile',
        invitationCode: 'Davet kodu',
        lastUpdated: 'Son güncelleme: {date}',
        guildMasterAddress: 'Guild lideri adresi',
        guildMasterBalance: 'Guild lideri mevcut TIA bakiyesi',
        tab: {
          rankByVolume: 'Hacme göre sıralama',
          rankByTVL: 'TIA bakiyesine göre sıralama'
        },
        table: {
          rank: 'Sıra',
          guild: 'Guild',
          status: 'Durum',
          balance: 'Bakiye',
          members: 'Üyeler',
          address: 'Adres',
          volumeRank: 'Hacim sıralaması',
          tvlRank: 'TIA Bakiye sıralaması',
          tradingVolume: 'İşlem hacmi',
          totalTIABalance: 'Toplam TIA Bakiyesi',
          totalTradingVolume: 'Toplam işlem hacmi',
          weightedAverageTiaBalance: 'Ağırlıklı ortalama TIA bakiyesi',
          tiaBalanceTooltip:
            'Yarışma süresi boyunca adreste tutulan TIA’nın ağırlıklı ortalaması',
          volumeTooltip:
            'Yarışma süresi boyunca adres tarafından oluşturulan taker ve maker işlem hacmi'
        }
      },
      createGuild: {
        cta: 'Guild Oluştur',
        title: 'Bir guild oluştur',
        characters: 'karakter',
        name: 'Guild adı',
        namePlaceholder: 'Ad girin',
        description: 'Guild açıklaması',
        thumbnail: 'Guild için bir görsel seç',
        masterAddress: 'Guild lideri adresi',
        findAGuildToJoin: 'Katılacak bir guild bul',
        insufficientBalance: 'Yetersiz bakiye',
        balanceInWallet: 'Cüzdandaki {symbol} bakiyesi:',
        insufficientBalanceDescription:
          'Bir guild liderinin, oluşturma anı da dahil olmak üzere, yarışma boyunca cüzdanında en az {amount} {symbol} bulundurması gerekir.'
      },
      joinGuild: {
        cta: 'Guild’e Katıl',
        maxCap: 'Maksimum Kapasite',
        title: 'Helix’te bir guild’e katıl',
        invitationCode: 'Discord’dan davet kodu al',
        description: '"{name}" adlı guild’e katılarak ödüllerden pay kazan!'
      },
      verifyJoinGuild: {
        cta: 'Katıl',
        hash: 'Davet kodu',
        title: 'Davet kodunu girin',
        incorrectCode: 'Geçersiz kod',
        hashPlaceholder: 'Davet kodunu girin',
        description: 'Bu guild’e katılmak için lütfen davet kodunu girin.'
      },
      alreadyPartOfGuild: {
        title: 'Zaten bir guild üyesi',
        description:
          '{address} zaten bir guild’in üyesi. Her adres yarışma boyunca yalnızca bir guild’e katılabilir.'
      }
    },
    toast: {
      error: 'Hata',
      success: 'Başarılı',
      addressCopied: 'Adres kopyalandı',
      viewOnInjScan: 'InjScan üzerinde görüntüle',
      contextCopied: 'İçerik kopyalandı!',
      marketIdCopied: 'Market ID kopyalandı',
      somethingHappened: 'Bir şeyler oldu...',
      connectedSuccessfully: 'Başarıyla bağlanıldı ',
      copiedAddressToClipboard: 'Adres panoya kopyalandı',
      formSubmittedSuccessfully: 'Form başarıyla gönderildi.',
      transactionFinalized:
        'İşlem {duration} saniyede tamamlandı. {viewOnInjScan}',
      onramperSuccess:
        'Başarılı! {fiatCurrency} karşılığında {cryptoAmount} {crypto} satın aldınız. Tokenlar yolda.',
      account: {
        authZAdded: 'AuthZ hesabı eklendi',
        assetsTransferred: 'Varlıklar hesabınıza aktarıldı',
        transferToSubaccountSuccess: 'Alt hesaba transfer başarılı'
      },
      authz: {
        connectedAs: 'Bağlanılan hesap'
      },
      portfolio: {
        buyInj: 'INJ Satın Al',
        bridgeNow: 'Hemen bridge et',
        bankTransferSuccessful: 'Transfer başarılı',
        startTradingInSeconds: 'Saniyeler içinde işlem yapmaya başla!',
        readyToTrade: 'İşlem yapmaya hazır mısın? Hemen marketleri keşfet!',
        moveAssetsToInj: 'Varlıklarını Ethereum’dan Injective’e taşı',
        discoverTrendingPairs:
          'Popüler pariteleri keşfet ve işlem yapmaya başla',
        moveAssetsToInjTitle:
          'Kriptonu Injective’e Taşı ve İşlem Yapmaya Başla',
        topUpWithCreditOrDebit:
          'Kredi veya banka kartıyla bakiye yükle, bugün işlem yapmaya başla.',
        autoSign: {
          disabledToast: 'Otomatik imzalama devre dışı',
          enabledToast: {
            title: 'Otomatik imzalama aktif',
            description: 'Otomatik imzalama 3 gün boyunca etkinleştirildi.'
          },
          enable: {
            title: 'Otomatik İmzalama',
            description:
              'Etkinleştirildiğinde, Helix’te her işlem için onay vermeden daha akıcı işlem yapabilirsin.'
          }
        }
      },
      trade: {
        invalidPrice: 'Geçersiz fiyat',
        orderCancelled: 'Emir iptal edildi',
        positionClosed: 'Pozisyon kapatıldı',
        noLiquidity: 'Yeterli likidite yok',
        orderPlaced: 'Emir başarıyla verildi',
        tpSuccessMessage: 'TP {price} olarak ayarlandı',
        slSuccessMessage: 'SL {price} olarak ayarlandı',
        allOrdersCancelled: 'Tüm emirler iptal edildi',
        orderUpdated: 'Emir başarıyla güncellendi',
        slOrderCancelled: 'Zararı durdur emri iptal edildi',
        successAddedMargin: 'Marjin başarıyla eklendi',
        tpOrderCancelled: 'Kâr al emri iptal edildi',
        advancedOrderCancelled: 'Gelişmiş emir iptal edildi',
        allAdvancedOrdersCancelled: 'Tüm gelişmiş emirler iptal edildi',
        rwaMarketClosedToast:
          'Bu market şu anda kapalı. Yine de işlem yapabilirsiniz, ancak ilgili risklere dikkat edin.',
        neptuneUsdt: {
          success: {
            deposit: 'Neptune yatırma işlemi başarılı',
            withdraw: 'Neptune çekme işlemi başarılı'
          }
        },
        tradeToast: {
          sold: '{quantity} {symbol}, ortalama ${usdPrice} fiyatla satıldı',
          bought:
            '{quantity} {symbol}, ortalama ${usdPrice} fiyatla satın alındı'
        }
      },
      referral: {
        referralLinkCopied: 'Referans bağlantısı kopyalandı',
        referralLinkIsUnavailable: 'Referans bağlantısı kullanılamıyor',
        success: 'Kodun başarıyla kullanıldı. Hemen marketleri keşfet!',
        referralLinkExists:
          'Bu cüzdana zaten başka bir referans kodu uygulandı',
        joinSelfReferralMessage:
          'Referans kodun geçerli ancak kendini refer edemezsin. Başkalarıyla paylaş!'
      },
      leaderboard: {
        receivedInformation:
          'Bilgilerinizi aldık; ekibimiz yakında sizinle iletişime geçecek'
      },
      campaign: {
        errorAlreadyClaimed: 'Ödül zaten alındı',
        notFound: 'Kampanya bulunamadı; lütfen daha sonra tekrar deneyin',
        successfullyClaimedRewards: 'Ödüller başarıyla alındı.'
      },
      guild: {
        successfullyJoinGuild: 'Guild’e başarıyla katıldınız',
        successfullyCreateGuild: 'Guild başarıyla oluşturuldu',
        copiedInvitationLink: 'Davet kodu panoya kopyalandı.'
      },
      tradingBots: {
        tradingBotRemovedSuccessfully: 'Alım-satım botu başarıyla kaldırıldı',
        tradingBotCreatedSuccessfully: 'Alım-satım botu başarıyla oluşturuldu'
      },
      stockTwits: {
        startHere: 'Buradan başla',
        title: '👋 Helix’e yeni misin?',
        description:
          'Kripto ve tokenize hisselerde kolayca işlem yapmaya başla.'
      }
    },
    trade: {
      tp: 'TP',
      sl: 'SL',
      fee: 'Komisyon',
      buy: 'Al',
      max: 'Maks',
      size: 'Büyüklük',
      info: 'Bilgi',
      long: 'Long',
      sell: 'Sat',
      spot: 'Spot',
      time: 'Zaman',
      open: 'Açık',
      sold: 'Satıldı',
      tpSl: 'TP/SL',
      chase: 'Takip Et',
      price: 'Fiyat',
      total: 'Toplam',
      limit: 'Limit',
      short: 'Short',
      chart: 'Grafik',
      depth: 'Derinlik',
      trade: 'İşlem',
      amount: 'Miktar',
      filled: 'Dolduruldu',
      market: 'Piyasa',
      trades: 'İşlemler',
      margin: 'Marjin',
      volume: 'Hacim',
      bought: 'Alındı',
      markets: 'Piyasalar',
      details: 'Detaylar',
      quantity: 'Miktar',
      leverage: 'Kaldıraç',
      standard: 'Standart',
      addTpSl: 'TP/SL Ekle',
      tickSize: 'Tick Boyutu',
      stopLoss: 'Zararı Durdur',
      postOnly: 'Sadece Gönder',
      noTrades: 'İşlem yok',
      noOrders: 'Emir yok',
      notAvailableNA: 'Yok',
      avgPrice: 'Ortalama Fiyat',
      direction: 'Yön',
      orderbook: 'Emir Defteri',
      editTpSl: 'TP/SL Düzenle',
      triggered: 'Tetiklendi',
      cancelled: 'İptal Edildi',
      markPrice: 'Mark Fiyatı',
      cancelAll: 'Tümünü İptal Et',
      addMargin: 'Marjin Ekle',
      viewOrder: 'Emri Görüntüle',
      orderType: 'Emir türü',
      'pro-chart': 'Pro Grafik',
      placeOrder: 'Emir Ver',
      allMarkets: 'Tüm Piyasalar',
      marketName: 'Piyasa Adı',
      takeProfit: 'Kâr Al',
      limitPrice: 'Limit Fiyat',
      worstPrice: 'En Kötü Fiyat',
      entryPrice: 'Giriş Fiyatı',
      reduceOnly: 'Sadece Azalt',
      profitLoss: 'Kâr/Zarar',
      balanceTitle: 'Kullanılabilir',
      openOrders: 'Açık Emirler',
      reduce_only: 'Sadece Azalt',
      'stop-limit': 'Zararı Durdur-Limit',
      derivatives: 'Türevler',
      liquidation: 'Tasfiye',
      advanced: 'Gelişmiş',
      slippage: 'Slippage',
      tickerOnly: 'Sadece {ticker}',
      cancelOrder: 'Emri İptal Et',
      showOrders: 'Siparişleri Göster',
      makerRate: 'Maker Komisyon Oranı',
      maxLeverage: 'Maks. Kaldıraç',
      'stop-market': 'Zararı Durdur-Piyasa',
      confirmTpSl: 'TP/SL Onayla',
      triggerPrice: 'Tetikleme Fiyatı',
      averagePrice: 'Ortalama Fiyat',
      'trading-bots': 'Alım-Satım Botları',
      emptyOrders: 'Emir bulunamadı',
      emptyTrades: 'İşlem bulunamadı',
      totalNotional: 'Toplam Nominal',
      closePosition: 'Pozisyonu Kapat',
      estFeeRebate: 'Tahmini Komisyon İadesi',
      partialFilled: 'Kısmen Dolduruldu',
      proceedAnyway: 'Yine de Devam Et',
      maxSlippage: 'Maks: {max}%',
      stopLossLimit: 'Zararı Durdur Limiti',
      searchMarket: 'Piyasa Ara...',
      boostedMarkets: 'Piyasa Ödülleri',
      priceDeviation: 'Fiyat Sapması',
      pnlPercent: 'K/Z% (Açık Pozisyon)',
      stopLossMarket: 'Zararı Durdur Piyasa',
      cancelStopLoss: 'Zararı Durdur İptal Et',
      availableMargin: 'Kullanılabilir Marjin',
      partiallyFilled: 'Kısmen Dolduruldu',
      cancelAllOrders: 'Tüm emirleri iptal et',
      takeProfitLimit: 'Kâr Al Limiti',
      enterYourAmount: 'Miktarınızı girin',
      advancedSettings: 'Gelişmiş Ayarlar',
      totalVolume: 'Toplam Hacim ({symbol})',
      stopLossQuantity: 'Zararı Durdur Miktarı',
      takeProfitMarket: 'Kâr Al Piyasa',
      cancelTakeProfit: 'Kâr Al İptal Et',
      availableAmount: 'Kullanılabilir: {amount}',
      makerTakerRate: 'Maker/Taker Komisyon Oranı',
      sharePnl: 'PNL Paylaş',
      noOrderHistory: 'Emir Geçmişi Yok',
      noTradeHistory: 'İşlem Geçmişi Yok',
      noOpenPositions: 'Açık Pozisyon Yok',
      slippageTolerance: 'Slipaj Toleransı',
      previousMarkPrice: 'Önceki Mark Fiyatı',
      totalQuantitySize: 'Toplam Miktar Boyutu',
      marketsInformation: 'Piyasalar Bilgisi',
      minLimitOrderSize: 'Min. Limit Emir Boyutu',
      bypassPriceWarning: 'Fiyat Uyarısını Atla',
      totalQuantity: 'Toplam Miktar ({symbol})',
      takeProfitQuantity: 'Kâr Al Miktarı',
      disqualifiedMarkets: 'Diskalifiye Piyasalar',
      estLiquidationPrice: 'Tahmini Tasfiye Fiyatı',
      stopLossTriggerPrice: 'Zararı Durdur Tetikleme Fiyatı',
      emptyAdvancedOrders: 'Gelişmiş Emir Bulunamadı',
      takeProfitTriggerPrice: 'Kâr Al Tetikleme Fiyatı',
      modifyTakeProfitStopLoss: 'Kâr Al / Zararı Durdur Değiştir',
      postOnlyWarning:
        'Zincir yükseltmesi nedeniyle geçici olarak sadece gönderme',
      minNotionalError: 'Minimum emir değeri > {minNotional} {symbol}',
      doNotShowThisConfirmationAgain: 'Bu onayı bir daha gösterme',
      availableMarginTooltip:
        'Bu pozisyona ekleyebileceğiniz kullanılabilir marjin',
      thereAreNoDisqualifiedMarketsOnThisRelayer:
        'Bu relayerda diskalifiye piyasa yok.',
      tensMultiplierRounded:
        'Otomatik olarak en yakın {minTickSize} katına aşağı yuvarlandı',
      markPriceInvalid:
        'Mark fiyat gereksinimini karşılamak için fiyat, miktar veya kaldıracı değiştirin',
      eip712Warning:
        'Yoğun kullanım nedeniyle, gazsız işlemler şu anda kullanılamıyor',
      slippageTooltip:
        'Slipaj toleransı, işlem iptal edilmeden önce izin verilen maksimum fiyat değişimidir.',
      makerTakerRateTooltip:
        'Maker emirleri {makerFeeRate}% ücret öder. Taker emirleri {takerFeeRate}% ücret öder.',
      stopLossDetails:
        'Mark Fiyat {price} olduğunda, {quantity} için Zararı Durdur Piyasa emri tetiklenecek.',
      takeProfitDetails:
        'Mark Fiyat {price} olduğunda, {quantity} için Kâr Al Piyasa emri tetiklenecek.',
      slippageWarning:
        'Slipaj % çok yüksek ayarlanırsa, işleminiz daha düşük fiyatla gerçekleşebilir.',
      positionUsedTooltip:
        '{quantity} başka bir emir için kullanılıyor. Açık emirlerinizi iptal veya değiştirebilirsiniz.',
      disqualifiedMarketsTooltip:
        'Trade & Earn’den diskalifiye edilmiş piyasalar. Bu piyasalarda yapılan işlemler ödül puanı kazandırmaz.',
      worstPriceTooltip:
        'En kötü fiyat, alımda ödeyeceğiniz en yüksek, satımda alacağınız en düşük fiyatı ifade eder ve slipaj toleransına bağlıdır.',
      chaseTooltip:
        'Takip Et’e tıklayarak bu açık limit emrini mevcut en iyi teklif/istek fiyatına otomatik güncelleyebilirsiniz. Bu özellik için otomatik imzalama açık olmalıdır.',
      boostedMarketsTooltip:
        'Her piyasadaki taker ve maker emirleri için ödül oranı. Örneğin: 3x maker pts, bu piyasada maker emirleri için ödenen işlem ücretlerinin 3 katı ödül puanı alınacağı anlamına gelir.',

      slippageModal: {
        title: 'Maksimum slippage ayarla',
        description:
          'Kabul etmeyi düşündüğünüz maksimum slippage değerini belirleyin. Fiyat bu yüzdeden daha fazla değişirse, emriniz gerçekleştirilmeyecektir.'
      },
      tab: {
        orders: 'Emirler',
        balances: 'Bakiyeler',
        positions: 'Pozisyonlar',
        openOrders: 'Açık Emirler',
        orderHistory: 'Emir Geçmişi',
        tradeHistory: 'İşlem Geçmişi',
        advancedOrders: 'Gelişmiş Emirler',
        fundingHistory: 'Fonlama Geçmişi',
        activeStrategies: 'Aktif stratejiler',
        removedStrategies: 'Kaldırılmış stratejiler'
      },
      rwa: {
        closed: 'Kapalı',
        nyseClosedTimes: 'NYSE işlem saatleri',
        statusOfThisMarket: 'Bu piyasanın durumu',
        rwaClosedTimes: ' geleneksel RWA fiyat beslemeleri',
        nyseClosedMarketRow: 'Bu piyasa NYSE işlem saatlerine uyuyor.',
        thisMayIncreaseYourTradingRisk: 'Bu işlem riskinizi artırabilir.',
        rwaClosedMarketRow:
          'Bu piyasa geleneksel RWA fiyat beslemelerini takip ediyor.',
        acknowledge:
          'Anladım, riski kabul ediyorum ve işlemi gerçekleştirmek istiyorum.',
        tradesCanBePlace:
          'Bu saatlerin dışında da işlem yapılabilir, ancak fiyatlar piyasa tekrar açılana kadar güncellenmez.',
        nyseMarketClosedTrade:
          'Helix’te tüm piyasalar 7/24 işlem görür. Ancak bu piyasa {nyseClosedTimes}, yani UTC 14:30 - 21:00 arası NYSE işlem saatlerini takip eder; geceleri, hafta sonları ve NYSE tatillerinde kapalıdır.',
        marketClosedTrade:
          'Helix’te tüm piyasalar 7/24 işlem görür. Ancak bu piyasa {marketClosedTimes} saatlerine uyar. Piyasalar Cuma 17:00 (ET) ile Pazar 17:00 (ET) arasında, CME tatillerinde ve Pazartesi-Perşembe 17:00 (ET) - 18:00 (ET) arası kapalıdır.'
      },
      stats: {
        low: '24s En Düşük',
        high: '24s En Yüksek',
        usdValue: 'USD Değeri',
        marketCap: 'Piyasa Değeri',
        annualized: 'Yıllık',
        nextFunding: 'Sonraki Fonlama',
        volumeInUsd: 'Hacim USD (24s)',
        marketVolume24h: 'Hacim (24s)',
        fundingOrCountdown: 'Fonlama / Geri Sayım',

        marketCapTooltip:
          'Piyasa değeri, güncel fiyat ile dolaşımdaki arzın çarpımıyla hesaplanır. Injective’daki bazı tokenlerin maksimum arzı sonsuzdur.',
        fundingRateTooltip:
          'Fonlama ödemeleri, perpetual fiyatı ile spot fiyat arasındaki fark üzerinden hesaplanır. Pozitifse longlar, negatifse shortlar ödeme yapar.',
        markPriceTooltip:
          'Marjin hesaplaması, gerçekleşmemiş K/Z ve fonlama oranları, tasfiyeler ve TP/SL emirleri için kullanılır.'
      },
      marketMultiplierBanner: {
        description:
          "Bu piyasa {startDate} itibarıyla {duration} saat boyunca 'Like a G' yarışması için {multiplier}x çarpanlar sunuyor. Çarpanlar daha sonra liderlik tablosuna yansıtılacaktır. {terms} geçerlidir."
      },
      equity: {
        spot: 'Spot',
        perps: 'Perps',
        title: 'Hesap Sermayesi',
        unrealizedPnl: 'Gerçekleşmemiş K/Z'
      },
      neptuneUsdt: {
        apy: 'APY',
        submit: 'Gönder',
        deposit: 'Yatır',
        neptune: 'Neptune',
        withdraw: 'Çek',
        available: 'Kullanılabilir',
        deposited: 'Yatırıldı',
        availableUSDT: 'Kullanılabilir USDT',
        depositToNeptune: "Neptune'a Yatır",
        percentageInReserve: '(%15 rezervde)',
        automatedYields: 'Helix Otomatik Getiriler',
        withdrawFromNeptune: "Neptune'dan Çek",
        availableUsdt: '≈{peggyUsdt} USDT + {neptuneUsdt} Neptune USDT',
        apyTooltip:
          'Bu, Neptune’un USDT mevduatlarına sunduğu güncel APY’dir. Zamanla değişecektir.',
        banner:
          'Helix, uygulamadan ayrılmadan stablecoinlerinizde getiri elde etmenizi kolaylaştırmak için Neptune ile ortaklık kurdu. Başlamak için {here} tıklayın!',
        description:
          'Stablecoinlerinizi {link} üzerindeki USDT kredi havuzuna yatırarak otomatik getiri elde edin. İşlem yapmak istediğinizde, fonlar otomatik olarak kredi havuzundan çekilir, ekstra adım gerekmez.',
        warningText:
          'İlerlemeniz durumunda, Injective tarafından kontrol edilmeyen veya ilişkili olmayan bir uygulamaya fon yatırmış olacaksınız. Bu uygulamayı kullanmanız tamamen sizin sorumluluğunuzdadır; oluşabilecek kayıplardan Injective sorumlu tutulamaz. Detaylar için Helix {terms} sayfasını inceleyin.'
      },
      stocksModal: {
        cta: 'İşlem Yapmaya Başla',
        description:
          'Dünyanın önde gelen merkeziyetsiz borsasında, 25x kaldıraçla zincir üstü hisse senedi vadeli işlemlerinde ilk işlem yapanlardan biri olun.'
      },
      marketRestricted: {
        tradeSpot: 'Spot İşlem Yap',
        cta: 'Ana sayfaya dön',
        swapCta: '{symbol} bölgenizde kullanılamıyor.',
        title: {
          spot: '{symbol} Kısıtlı',
          perpetual: 'Sürekli İşlemler Kısıtlı'
        },
        description: {
          spot: 'Düzenleyici kısıtlamalar nedeniyle {symbol} bölgenizde kullanılamıyor.',
          perpetual:
            'Düzenleyici kısıtlamalar nedeniyle sürekli kontratlar bölgenizde kullanılamıyor. Ancak spot piyasada işlem yapabilirsiniz.'
        }
      },
      marketNotOnHelix: {
        cta: 'Anladım',
        title: 'Deneysel piyasa',
        termsAndCondition: 'Şartlar ve Koşullar',
        description:
          "Injective üzerinde mevcut ancak Helix'te listelenmeyen bir piyasaya erişiyorsunuz. Lütfen işlem yapmak istediğiniz Piyasa ID'sinin doğru olduğundan emin olun.",
        description2:
          "Devam ederek Helix'i kullanmanız durumunda Helix {0}’i okuduğunuzu, kabul ettiğinizi ve bağlı olduğunuzu onaylamış olursunuz."
      },
      sharePnlModal: {
        markPrice: 'Gösterge fiyat',
        exitPrice: 'Çıkış fiyatı',
        entryPrice: 'Giriş fiyatı',
        mobileDownloadNote: 'İndirme sadece masaüstünde mevcut'
      },
      leverageModal: {
        title: 'Kaldıraç Ayarla',
        upTo: 'En fazla {leverageAmount}x',
        leverageAt: 'Kaldıraç {leverageAmount}x seviyesinde',
        description:
          'Yüksek kaldıraç getirileri artırabilir, ancak tasfiye olma riskini de yükseltir.'
      },
      partialClosePositionModal: {
        limitClose: 'Limit Kapat',
        marketClose: 'Piyasa Kapat',
        marketTitle: 'Kısmi pozisyon kapatma',
        totalPositionSize: 'Toplam pozisyon büyüklüğü'
      },
      table: {
        markets: {
          markets: 'Piyasalar',
          'last-price': 'Son Fiyat',
          'market-change-24h': 'Değişim (24s)',
          'market-volume-24h': 'Hacim (24s)'
        },
        marketsSelector: {
          markets: 'Piyasalar',
          'last-price': 'Son Fiyat',
          'market-volume-24h': 'Hacim (24s)',
          'market-change-24h': 'Değişim (24s)',
          'funding-rate': 'Tahmini Fonlama (1s)'
        }
      }
    },
    vault: {
      TVL: 'TVL',
      APY: 'APY',
      title: 'Mito Vault’larıyla Getirinizi Maksimize Edin',
      description:
        'Mito’nun otomatik piyasa yapıcı vaultları ile kripto varlıklarınızı güçlendirin. Injective ekosistemindeki önde gelen projelere likidite sağlayarak bugün pasif gelir kazanmaya başlayın.',
      item: {
        'mito-vault': 'LP Vault’ları',
        'injective-staking': 'Staking',
        'helix-spot-grid-bot': 'Spot Grid İşlem Botları'
      },
      modal: {
        continueToMito: 'Mito’ya Devam Et',
        redirect:
          'Vault’lara girerseniz, Helix’ten Mito’ya yönlendirileceksiniz ve burada getiri kazanabilirsiniz.'
      }
    },
    markets: {
      vol: 'Hacim',
      marketId: 'Piyasa ID',
      showLowVol: 'Düşük hacmi göster',
      newMarkets: '🐤 Yeni Piyasalar',
      topGainers: '🚀 En Çok Kazananlar',
      closePositionWarningTitle: 'Yüksek fiyat etkisi tespit edildi',
      docsTooltip:
        'Bu ürün bir Endeks Perpetual’dür. Daha fazla bilgi için {docs}’e bakınız.',
      expiryDocsTooltip:
        'Bu ürün bir Vade Sonu Vadeli İşlem sözleşmesidir. Daha fazla bilgi için lütfen {docs} adresine bakın.',
      indexMarketTooltip:
        'Bu piyasa {label} değerini takip eder. Daha fazla detay için {link}’e bakınız.',
      closePositionWarningDescription:
        'Bu açık pozisyonu piyasa emriyle kapatmak istenmeyen bir fiyatla sonuçlanabilir. Bunun yerine limit emirle kapatmayı düşünebilirsiniz.',
      '2024ElectionTooltip':
        'Bu piyasa, TRUMPWIN teminatlı Polymarket 2024 Başkanlık Seçimi fiyat beslemesini takip eder. Daha fazla detay için {docs}’i ziyaret edin.',
      filters: {
        all: 'Tümü',
        favorites: 'Favoriler',
        perps: 'Perpetual',
        spot: 'Spot',
        trending: 'Trend',
        injective: 'Injective',
        'layer-1': 'L1',
        deFi: 'DeFi',
        ai: 'AI',
        rwa: 'RWA'
      }
    },
    connect: {
      beta: 'Beta',
      wallet: 'Cüzdan',
      trezor: 'Trezor',
      address: 'Adres',
      ledgerLive: 'Ledger Live',
      trezorBip44: 'Trezor Bip44',
      getAddresses: 'Adresleri al',
      ledgerLegacy: 'Ledger Legacy',
      walletAddress: 'Cüzdan Adresi',
      connectWallet: 'Cüzdanı Bağla',
      derivationPath: 'Türetim Yolu',
      showMoreWallets: 'Daha fazla cüzdan göster',
      showLessWallets: 'Daha az cüzdan göster',
      injectiveAddress: 'Injective Adresi',
      getMoreAddresses: 'Daha fazla adres al',
      selectDerivationPath: 'Türetim Yolunu Seç',
      connectUsingBrowser: 'Tarayıcı cüzdanıyla bağlan',
      selectAddressToConnect: 'Bağlanacak adresi seç',
      connectUsingHardware: 'Donanım cüzdanıyla bağlan',
      connectDeprecatedSSO: 'Kullanımdan kalkmış giriş ile bağlan',
      qrTitle: 'Bu adrese sadece INJ ağ varlıkları yatırın',
      otpDescription:
        'E-postanızı doğrulamak için tek kullanımlık kodunuzu girin',
      getAddressNote: 'Adresleriniz alınıyor, lütfen bekleyin ...',
      pleaseConnectToYourWallet:
        'Daha fazla detay görmek için lütfen cüzdanınızı bağlayın',
      pleaseConnectToYourWalletCta:
        'Injective üzerinde işlem yapmaya başlamak için lütfen cüzdanınızı bağlayın!',
      connectUsingTrezorNote:
        'Not: Trezor donanım cüzdanınızı bağlarken sorunsuz işlem için en son Chrome sürümünü kullandığınızdan, cihazınızın bağlı ve kilidinin açık olduğundan emin olun.',
      connectUsingLedgerNote:
        'Not: Ledger donanım cüzdanınızı bağlarken sorunsuz işlem için en son Chrome sürümünü kullandığınızdan, cihazınızın bağlı, kilidinin açık ve Ethereum uygulamasının çalışır durumda olduğundan emin olun.',
      sso: {
        google: {
          cta: 'Google ile giriş yap'
        },
        email: {
          cta: 'Devam et',
          placeholder: 'E-posta adresiniz'
        }
      },
      deprecate: {
        cta: 'Cüzdanı Taşı',
        title: 'Eylem gerekli: cüzdanınızı taşıyın',
        description:
          'Cüzdan sağlayıcımızı yükseltiyoruz ve mevcut olan sizin için kullanımdan kaldırılıyor. Cüzdanınızı taşımak için aşağıdakileri yapmanızı şiddetle tavsiye ederiz',
        migrateDescription:
          'Oturum açma yöntemimizi daha hızlı, basit ve güvenli hale getirdik. Helix’i kullanmaya devam etmek için lütfen güncellenmiş cüzdanınızı bağlayarak varlıklarınızı taşıyın. Sadece bir an sürer ve fonlarınız her zaman güvendedir.'
      },
      option: {
        leap: 'Leap',
        keplr: 'Keplr',
        ninji: 'Ninji',
        rabby: 'Rabby',
        ledger: 'Ledger',
        phantom: 'Phantom',
        rainbow: 'Rainbow',
        metamask: 'Metamask',
        'trezor-bip32': 'Trezor',
        'trezor-bip44': 'Trezor Bip44',
        'okx-wallet': 'OKX Cüzdan',
        BitGet: 'Bitget Cüzdan',
        magic: '"Eski giriş"',
        'trust-wallet': 'Trust Cüzdan',
        cosmostation: 'Cosmostation',
        'wallet-connect': 'Wallet Connect'
      }
    },
    points: {
      rank: 'Sıralama',
      level: 'Seviye',
      share: 'Paylaş',
      title: 'Puanlar',
      period: 'Dönem',
      points: 'Puanlar',
      volume: 'Hacim',
      paginationDetails: '{from}-{to} / {total}',
      leagues: {
        blue: 'Mavi Kuşak',
        black: 'Siyah Kuşak',
        white: 'Beyaz Kuşak',
        orange: 'Turuncu Kuşak',
        purple: 'Mor Kuşak'
      }
    },
    banners: {
      findOutMore: 'Daha fazla bilgi edinin',
      stockTwits:
        'Nasıl işlem yapılacağını veya tokenleştirilmiş hisse senetlerinin nasıl ticaretinin yapıldığını öğrenmek ister misiniz? → {learnMore}',
      deprecatedWallet:
        'Bu cüzdan kullanımdan kaldırılmıştır. Fonlarınızı taşımak için taşıma kılavuzunu izleyin. {learnMore}',
      deprecatedWalletWithAddress:
        'Bu cüzdan kullanımdan kaldırılmıştır. Yeni SSO adresiniz {address}. Fonlarınızı taşımak için taşıma kılavuzunu izleyin. {learnMore}',
      postOnly:
        'Sadece emir modu aktif: Son zincir yükseltmesinden sonra, yeni limit emirleri verilebilir, ancak piyasa emirleri ve anlık eşleşmeler 2000 blok boyunca kullanılamaz. {link}',
      settlePerpMarketBanner:
        'Bu piyasayı zorunlu kapatma amaçlı bir yönetişim önerisi bulunmaktadır. Açık pozisyonlarınızı kapatmanız teşvik edilir, aksi takdirde tasfiye fiyatından zorunlu tasfiye yapılacaktır.',
      settlePerpMarketBannerNewLaunch:
        'There is currently a live governance proposal to force settle the WTI PERP market. You are encouraged to close open positions, or your position will be force settled at the mark price at the time of settlement. After this market is settled, a new expiry futures market will be launched.',
      pointsS1Ended:
        'Helix Puanları 1. Sezon sona erdi. Katılımınız için teşekkürler, daha fazla güncelleme için bizi takipte kalın!',
      expiryFuturesBanner:
        'Bu bir vade sonu vadeli işlem işlem çiftidir ve {date} tarihinde sonlandırılacaktır. Bu zamandan sonra açık kalan tüm pozisyonlar, vade sonundaki işaret fiyatı üzerinden zorunlu olarak kapatılacaktır.',
      mkrExpiry:
        'MKR’den SKY’a geçişin bir parçası olarak, bu işlem çifti (yönetim onayına bağlı olarak) 14 Eylül’de zorunlu olarak kapatılacaktır. O tarihte hâlâ açık olan tüm pozisyonlar, vade sonundaki işaret fiyatı üzerinden zorunlu olarak kapatılacaktır.',

      kado: {
        getStarted: 'Başlayın',
        title: 'Helix 2.0 ile tanışın! Yepyeni bir ticaret deneyimi keşfedin.'
      },
      stocks: {
        description:
          'Hızlı, ucuz ve daha şeffaf işlemler için kripto ile hisse senetleri alım satımı yapın - geleneksel piyasalar ile merkeziyetsiz finansın gücünü birleştiriyor.'
      },
      userFeedback: {
        threeMinutes: '3 dakika ',
        notRightNow: 'Şu anda değil',
        takeSurvey: 'Ankete katıl',
        loveFeedback: 'Geri bildiriminizi duymak isteriz!',
        thankYouEnd:
          ' tamamlamak için ve bu bilgiler Helix üzerindeki gelecekteki deneyiminizi geliştirmemize yardımcı olacak.',
        thankYouBeginning:
          "Helix'i kullandığınız için teşekkürler. Kullanıcılarımıza daha iyi ürünler sunmak için sürekli çalışıyoruz ve sizden geri bildirim almak isteriz! Anketin tamamlanması 3 dakikadan az sürecektir."
      },
      newFeature: {
        cta: 'TradFi ile işlem yap',
        title: 'TradFi Hisse Senetleri Endeksi ile tanışın!',
        description:
          'Büyük halka açık hisse senetlerini ilk kez tek entegre bir endeks üzerinden zincir üzerinde işlem yapın. En düşük ücretler ve 25X’e kadar kaldıraç ile TradFi’ya 7/24 erişim sadece Helix’te.'
      },
      leaderboard: {
        currentCompetitionLink: 'Daha fazlasını gör',
        currentCompetitionTitle:
          'Helix Alım-Satım Kampanyasına Katıl – 25.000$ ödül seni bekliyor! 9-23 Ekim {linkDescription}',
        gwagon: {
          title: 'Bir G Gibi İşlem Yap',
          description:
            'Bir G-Wagon kazanma şansı için işlem yapın! 1 Ekim 14:00 UTC’den 22 Ekim 14:00 UTC’ye kadar, en yüksek PnL işlemcisi ve şanslı çekiliş kazananı olmak üzere iki G-Wagon’dan birini kazanma şansı yakalayın. Her 10$ işlem hacmi bir giriş hakkı kazandırır. Daha fazla detay için {blog}’a bakın.'
        },
        tesla: {
          title: 'Tesla Kazanın!',
          description:
            'Tesla kazanma şansı için işlem yapın! 26 Kasım 15:00 UTC’den 6 Aralık 15:00 UTC’ye kadar, en yüksek PnL işlemcisi Tesla Model 3 kazanacak. Daha fazla detay için {blog}’a bakın.'
        },
        ownYourAsset: {
          title: 'Varlıklarınızı Sahiplenin, Geleceğinizi Kontrol Edin.',
          description:
            'Helix’te 50.000$ ödül havuzundan payınızı almak için yarışın. 21 Şubat 2025 18:00 UTC’den 3 Mart 2025 18:00 UTC’ye kadar, 50.000$ ödül havuzundan 1.000$ kazanma şansı için işlem yapabilirsiniz. Her 1.000$ işlem hacmi bir giriş hakkı sağlar. Daha fazla detay için {blog}’a bakın.'
        },
        volumeVictory: {
          title: 'Hacim = Zafer',
          description:
            "Everything Exchange'de yapılan her 1.000 $'lık işlem seni 25.000 $ ödül havuzundaki payına bir adım daha yaklaştırır."
        }
      }
    },
    referral: {
      share: 'Paylaş',
      approve: 'Onayla',
      referNow: 'Şimdi Davet Et',
      noReferrals: 'Davet Yok',
      referralLink: 'Davet Linki',
      referAndEarn: 'Davet Et ve Kazan',
      confirmReferral: 'Davet Onayla',
      referralDetails: 'Davet Detayları',
      scanToJoin: "Helix'e katılmak için tara veya",
      yourReferralLink: 'Davet Linkiniz',
      checkAvailability: 'Uygunluğu Kontrol Et',
      affiliatedAddress: 'Bağlı Adres',
      startEarningToday: 'Bugün kazanmaya başla',
      createReferralLinkPlaceholder: 'BULLISH',
      customReferralCode: 'Özel Davet Kodu',
      chooseDifferentLink: 'Farklı Link Seç',
      dashboardTitle: 'Tüccarları Davet Et, Ödüller Kazan',
      referralLinkAvailable: 'Davet Linki Uygun!',
      lettersAndNumbersOnly: 'sadece harf ve rakamlar',
      confirmAndGenerateLink: 'Onayla ve Link Oluştur',
      createReferralLinkTitle: 'Davet Linkinizi Oluşturun',
      trackYourReferrals:
        'Davetlerinizi ve kazandığınız komisyonları takip edin',
      shareYourReferralLink:
        'Davet linkinizi paylaşarak arkadaşlarınızı davet edin.',
      referralCodeMaxLengthMessage: 'Davet kodu en fazla 32 karakter olabilir',
      dashboardSubtitle:
        'Kullanıcıları davet ederek ödül kazanın. Ortaklar daha yüksek ödüller kazanır.',
      createReferralLinkSubtitle:
        'Davetlerinizi takip etmek için benzersiz bir link seçin. Hatırlanması kolay ve paylaşımı basit olsun.',
      rewardsTooltipContent:
        'Başarılı davetlerden kazandığınız toplam komisyon. Ödüller, davetlerinizin işlem hacmine göre hesaplanır.',
      referralLinkAvailableDescription:
        'Davet kodunuz {baseUrl}/ref/{referralCode} uygun durumda. Bu linki kullanmak ister misiniz?',
      confirmReferralDescription:
        'Bu adresle {baseUrl}/ref/{referralCode} üzerinden davet edileceksiniz. Bağlanmak istiyorsanız lütfen onaylayın.',
      table: {
        wallets: 'Cüzdanlar',
        'join-date': 'Katılım Tarihi',
        commission: 'Komisyon'
      },
      myStats: {
        title: 'İstatistiklerim',
        rewardsEarned: 'Kazandığınız Ödüller',
        tradersReffered: 'Davet Edilen Tüccarlar'
      },
      referFriends: {
        title: 'Arkadaşlarını Nasıl Davet Edersin',
        step3Title: 'Ödülleri Otomatik Al',
        step2Title: 'Arkadaşlarını Davet Et, %40 Kazan',
        step1Title: 'Davet Linkini Paylaş',
        step2Description: 'İstediğin kadar arkadaşını ekle.',
        description1: "Ağınızı Helix'te işlem yapmaya davet edin",
        step1Description: 'Benzersiz linkinizi oluşturabilirsiniz.',
        description2: " ve komisyon olarak ücretlerinin %40'ını kazanın.",
        step3Description: 'Ödüllerinizi kripto cüzdanınızda anında alın.'
      },
      shareModal: {
        title: 'Arkadaşlarını Davet Et!',
        customizeYourText: 'Metnini Özelleştir',
        description: "QR kodunu tara ve Helix'e katıl!",
        defaultText:
          "Ödüllerini takip et ve istediğin zaman çek. Ağını Helix'te işlem yapmaya davet et ve ücretlerinin %40'ını komisyon olarak kazan."
      }
    },
    lpRewards: {
      volume: 'Hacim',
      overall: 'Genel',
      address: 'Adres',
      rewards: 'Ödüller',
      ongoing: 'Devam Ediyor',
      title: 'LP Ödülleri',
      letsGo: 'Hadi Başlayalım!',
      round: '{round}. Tur',
      myRewards: 'Benim Ödüllerim',
      allRewards: 'Tüm Ödüller',
      estRewards: 'Tahmini Ödüller',
      totalVolume: 'Toplam Hacim',
      rewardStats: 'Ödül İstatistikleri',
      addLiquidity: 'Likidite Ekle',
      rewardsRound: 'Ödüller/Tur',
      campaignRules: 'Kampanya Kuralları',
      rewardsDetails: 'Ödül Detayları',
      rewardsToClaim: 'Alınacak Ödüller',
      volumeThisRound: 'Bu Turdaki Hacim',
      lastUpdated: 'Son güncelleme {date}',
      dashboardTitle: 'LP Ödülleri Paneli',
      myRewardsCount: 'Benim Ödüllerim ({rewards})',
      noActiveCampaigns: 'Aktif kampanya yok',
      endTimeForRound: '{round}. Tur için Bitiş Zamanı',
      totalRewardsAllTime: 'Toplam Ödüller (Tüm Zamanlar)',
      totalRewardsThisRound: 'Bu Turdaki Toplam Ödüller',
      totalRewardsOfRound: '{round}. Turdaki Toplam Ödüller',
      helixLpRewardsRound: 'Helix LP Ödülleri {round}. Tur',
      description: 'Farklı spot piyasalarda işlem yaparak ödül kazanın',
      rewardsPending:
        'LP Ödülleri Beklemede: Bu çift için ödüller şu anda işleniyor. Fonlama turun bitiminden sonra bir haftaya kadar sürebilir.',
      legacyBotWarning:
        'Uyarı: LP ödüllerini kaçırıyorsunuz! Eski piyasa stratejinizi durdurun ve yeni piyasada yeni bir tane oluşturun, ödüller kazanmaya başlayın.',
      roundIsLive:
        '{round1} başladı! Bu tura eklenen yeni piyasalara göz atın! {round2} turundan ödüllerinizi almak için sayfadaki {myRewards} bölümüne gidin.',
      table: {
        liquidity: {
          market: 'Piyasa',
          volume: 'Hacim',
          rewards: 'Ödüller',
          'active-bots': 'Aktif Botlar'
        },
        dashboard: {
          market: 'Piyasa',
          volume: 'Hacim',
          rewards: 'Ödüller',
          'est-rewards': 'Tahmini Ödüller'
        }
      }
    },
    portfolio: {
      swaps: 'Swapler',
      staked: 'Stake Edilen',
      positions: 'Pozisyonlar',
      spotOrders: 'Spot Emirleri',
      assetsFrom: 'Varlıklar Kaynağı',
      totalValue: 'Toplam Değer',
      tradeHistory: 'İşlem Geçmişi',
      orderHistory: 'Emir Geçmişi',
      noOpenOrders: 'Açık Emir Yok',
      fundingHistory: 'Fonlama Geçmişi',
      advancedOrders: 'Gelişmiş Emirler',
      derivativeOrders: 'Türev Emirleri',
      noTransferHistory: 'Transfer bulunamadı',
      noFundingHistory: 'Fonlama geçmişi bulunamadı',
      showUnverifiedAssets: 'Doğrulanmamış varlıkları göster',
      notAvailableinAuthZOrAutoSignMode:
        'Erişim Kontrol Modu veya Otomatik İmzalama Modunda kullanılamaz',
      tab: {
        pnl: 'PNL',
        account: 'Hesap'
      },
      home: {
        stakedInj: 'Stake Edilen INJ',
        yieldBearingUsdt: 'Getiri Sağlayan USDT',
        unrealizedPositions: 'Gerçekleşmemiş Pozisyonlar',
        volume: {
          title: 'İşlem Hacmi (Haftalık)'
        },
        balance: {
          title: 'Portföy Değeri'
        },
        tradableBalance: {
          title: 'İşlem Yapılabilir Değer'
        },
        pnl: {
          title: 'İşlem PnL',
          tooltip:
            'Portföy sayfasındaki kar ve zarar hesaplamaları, 29 Mayıs 2024 tarihinden itibaren Helix’te açılıp kapanan pozisyonlardan yaklaşık gerçekleşen kar ve zararı yansıtır. Bu hesaplama yalnızca bilgilendirme amaçlıdır ve vergi bildirim yükümlülükleri için kullanılmamalıdır.'
        }
      },
      balances: {
        netWorth: 'Net Değer',
        transferToMain: 'Ana Hesaba Transfer Et'
      },
      subaccounts: {
        addSubaccountOrTransfer: 'Alt Hesap Ekle / Transfer',
        accountEndBot:
          'Fonları ana hesabınıza aktarmak için lütfen mevcut Spot Grid Trading Botunuzu durdurun. Bu işlem fonlarınızın otomatik olarak transferini başlatacaktır.',
        description:
          'Bu, dijital varlıkların ayrı yönetimi ve işlemi için ana hesabınıza bağlı bir yan hesaptır. Aktifleştirmek için önce fon transferi yapmanız gerekir. Alt hesaplar hakkında daha fazla bilgiyi SSS bölümümüzde bulabilirsiniz.'
      },
      settings: {
        title: 'Ayarlar',
        account: 'Hesap',
        notAvailableinAuthZMode: 'Erişim Kontrol Modunda kullanılamaz',
        preferences: {
          title: 'Tercihler',
          eip712: {
            title: 'EIP-712 İmzalamayı Etkinleştir'
          },
          autosign: {
            description:
              'Otomatik imzalama, işlemleri cüzdanınızda manuel onaylamadan yapmanızı sağlar',
            tooltip:
              'Etkinleştirildiğinde, işlemleri 3 güne kadar imzalamanız gerekmez ve istediğiniz zaman kapatabilirsiniz.'
          },
          thousandsSeparator: {
            title: 'Binlik Ayırıcı',
            description:
              'Büyük sayıları daha kolay okunması için virgülle ayırır. Örnek: 1234567 → 1.234.567'
          },
          gridTradingSubaccounts: {
            title: 'Grid Trading Alt Hesaplarını Göster',
            description:
              'Grid trading için ayrılmış alt hesapların listesini göster'
          }
        }
      },
      filters: {
        byType: 'Türüne Göre Filtrele',
        bySide: 'Tarafa Göre Filtrele',
        byAsset: 'Varlığa Göre Filtrele',
        byMarket: 'Piyasaya Göre Filtrele',
        cleanFilters: 'Filtreleri Temizle'
      },
      connectMobile: {
        grantAccess: 'Erişim Ver',
        scanCode: 'Devam Etmek İçin Kodu Tara',
        scanQRCode:
          'Cüzdanınızı bağlamak için bu QR kodunu mobil cihazınızla tarayın'
      },
      bankTransfer: {
        title: 'Transfer',
        enterAddress: 'Injective Adresini Girin',
        doubleCheck:
          'Lütfen adresi kontrol edin. Yanlış adrese gönderilen tokenler kurtarılamaz.',
        memo: {
          title: 'Not (Memo)',
          required: 'Gerekli',
          placeholder: 'Not girin (çoğu merkezi borsa için gerekli)'
        }
      },
      duration: {
        '1D': '1G',
        '1W': '1H',
        '1M': '1A'
      },
      walletHistory: {
        subaccountDepositType: 'Cüzdandan Alt Hesaba',
        subaccountWithdrawalType: 'Alt Hesaptan Cüzdana',
        subaccountInternalTransferType: 'Alt Hesaptan Alt Hesaba'
      },
      keyStats: {
        title: 'Ana İstatistikler',
        allTimePnl: 'Tüm Zamanlar PNL',
        totalVolume: 'Toplam Hacim',
        totalEquity: 'Toplam Sermaye',
        stakingAccount: 'Stake Hesabı',
        spotAccountEquity: 'Spot Hesap Sermayesi',
        perpsAccountEquity: 'Perpetual Hesap Sermayesi'
      },
      authZ: {
        title: 'Erişim Kontrol Yönetimi',
        description:
          'Başka cüzdan adreslerine kendi adınıza işlem yapma için tam/kısmi yetki verin',
        revoke: 'Yetkiyi Geri Al',
        actions: 'İşlemler',
        grantee: 'Yetki Alan',
        granter: 'Yetki Veren',
        revokeAll: 'Tüm Yetkileri Geri Al',
        connectAs: 'Olarak Bağlan',
        noGrants: 'Yetki bulunamadı',
        authZAs: '{address} olarak AuthZ',
        granteeAddress: 'Yetki Alan Adres',
        grantedFunctions: 'Verilen Yetkiler',
        connectMobile: 'Mobil Cihaz Bağla',
        addNewGrantee: 'Yeni yetki alan adres ekle',
        addGranteeAddress: 'Yetki alan adres ekle',
        viewGrantedFunctions: 'Verilen yetkileri görüntüle',
        notAvailableinAutoSignMode: 'Otomatik İmzalama Modunda kullanılamaz'
      },
      autoSign: {
        title: 'Otomatik İmza',
        durationDescription: 'Otomatik imza 3 gün boyunca aktiftir.',
        pageTitle: 'Otomatik İmza: İşlemleri Otomatik Onayla',
        content1: {
          description1: "Etkinleştirildiğinde, Helix'i kullanırken",
          description2: 'her işlemi 3 gün boyunca imzalamanıza gerek kalmaz.'
        },
        content2: {
          title: 'Şunlar için kullanabilirsiniz:',
          description1: 'Pozisyon açma/kapatma (spot ve perpetual çiftlerde)',
          description2: 'Limit emir ayarlama',
          description3: 'Kar al / Zarar durdur (TP/SL) emirleri oluşturma'
        },
        content3: {
          title: 'Not:',
          description1: 'Swap ve işlem botları dahil değildir.',
          description2:
            'Güvenlik nedeniyle, oturum 3 gün sonra otomatik sona erer.',
          description3:
            'Bittiğinde istediğiniz zaman yeni bir oturum başlatabilirsiniz.'
        },
        expiredToast: {
          settings: 'Ayarlar',
          title: 'Otomatik imza oturumu sona erdi',
          description: 'Yeni oturumu {settings} bölümünden başlatabilirsiniz.'
        }
      },
      table: {
        fundingHistory: {
          time: 'Zaman',
          pair: 'Çift',
          payment: 'Ödeme'
        },
        subaccounts: {
          name: 'Alt Hesap Adı',
          address: 'Alt Hesap Adresi',
          'total-usd': 'Toplam Değer (USD)'
        },
        historySwap: {
          fee: 'Ücret',
          time: 'Zaman',
          route: 'Rota',
          outgoing: 'Giden',
          incoming: 'Gelen'
        },
        historyWallet: {
          time: 'Zaman',
          type: 'Tür',
          asset: 'Varlık',
          amount: 'Miktar',
          origin: 'Kaynak',
          destination: 'Hedef'
        },
        balance: {
          total: 'Toplam',
          assets: 'Varlıklar',
          staked: 'Stake Edilen',
          available: 'Kullanılabilir',
          'staked-usd': 'Stake Edilen (USD)',
          'total-usd': 'Toplam Değer (USD)',
          'unrealized-pnl': 'Gerçekleşmemiş Kar/Zarar',
          'used-or-reserved': 'Kullanılan/Rezerv'
        },
        spotOpenOrder: {
          side: 'Taraf',
          price: 'Fiyat',
          chase: 'Takip Et',
          action: 'İşlem',
          market: 'Piyasa',
          amount: 'Miktar',
          filled: 'Dolduruldu',
          unfilled: 'Doldurulmadı',
          'total-amount': 'Toplam Miktar'
        },
        spotOrderHistory: {
          type: 'Tür',
          side: 'Taraf',
          price: 'Fiyat',
          total: 'Toplam',
          status: 'Durum',
          market: 'Piyasa',
          amount: 'Miktar',
          'last-updated': 'Son Güncelleme',
          'trigger-condition': 'Tetikleyici Koşul'
        },
        spotTradeHistory: {
          fee: 'Ücret',
          time: 'Zaman',
          pair: 'Çift',
          type: 'Tür',
          side: 'Taraf',
          total: 'Toplam',
          price: 'Fiyat',
          amount: 'Miktar'
        },
        futuresOpenOrder: {
          side: 'Taraf',
          price: 'Fiyat',
          total: 'Toplam',
          chase: 'Takip Et',
          action: 'İşlem',
          market: 'Piyasa',
          amount: 'Miktar',
          filled: 'Dolduruldu',
          unfilled: 'Doldurulmadı',
          leverage: 'Kaldıraç'
        },
        futuresOrderHistory: {
          type: 'Tür',
          side: 'Taraf',
          price: 'Fiyat',
          total: 'Toplam',
          status: 'Durum',
          market: 'Piyasa',
          amount: 'Miktar',
          'last-updated': 'Son Güncelleme',
          'trigger-condition': 'Tetikleyici Koşul'
        },
        futuresTradeHistory: {
          fee: 'Ücret',
          time: 'Zaman',
          type: 'Tür',
          side: 'Taraf',
          price: 'Fiyat',
          total: 'Toplam',
          market: 'Piyasa',
          amount: 'Miktar',
          pnl: 'Kapanış Kar/Zarar'
        },
        futuresAdvancedOrders: {
          type: 'Tür',
          side: 'Taraf',
          price: 'Fiyat',
          total: 'Toplam',
          action: 'İşlem',
          market: 'Piyasa',
          amount: 'Miktar',
          leverage: 'Kaldıraç',
          'trigger-condition': 'Tetikleyici Koşul'
        },
        position: {
          side: 'Taraf',
          'tp-or-sl': 'TP/SL',
          market: 'Piyasa',
          mark: 'İşaret Fiyatı',
          entry: 'Giriş Fiyatı',
          leverage: 'Kaldıraç',
          contracts: 'Sözleşmeler',
          margin: 'Pozisyon Teminatı',
          'total-usd': 'Toplam Değer (USD)',
          'liquidation-price': 'Tasfiye Fiyatı',
          'close-position': 'Pozisyonu Kapat',
          'unrealized-pnl': 'Gerçekleşmemiş Kar/Zarar'
        }
      }
    },
    navigation: {
      spot: 'Spot',
      swap: 'Swap',
      trade: 'Ticaret',
      swaps: "Swap'lar",
      stocks: 'Hisseler',
      points: 'Puanlar',
      orders: 'Emirler',
      markets: 'Piyasalar',
      history: 'Geçmiş',
      balances: 'Bakiyeler',
      settings: 'Ayarlar',
      portfolio: 'Portföy',
      positions: 'Pozisyonlar',
      myAccount: 'Hesabım',
      disconnect: 'Bağlantıyı Kes',
      derivative: 'Türev',
      noTierLevel: 'VIP Seviyesi Yok',
      subaccounts: 'Alt Hesaplar',
      leaderboard: 'Liderlik Tablosu',
      tradingBots: 'Ticaret Botları',
      fundingHistory: 'Fonlama Geçmişi',
      subaccountHistory: 'Alt Hesap Geçmişi',
      makerTakerFee: '-{maker}% yapıcı / -{taker}% alıcı',
      more: {
        olp: 'OLP',
        title: 'Daha Fazlası',
        vaults: 'Kasa',
        bridge: 'Köprü',
        deposit: 'Para Yatır',
        referral: 'Tavsiye',
        lpRewards: 'LP Ödülleri'
      }
    },
    footer: {
      blog: 'Blog',
      v2: ' Versiyon 2.0',
      support: 'Destek',
      docs: 'Helix Belgeleri',
      explorer: 'Gezgin',
      resources: 'Kaynaklar',
      community: 'Topluluk',
      operational: 'Operasyonel',
      feeDiscounts: 'Ücret İndirimleri',
      institutional: 'Kurumsal',
      privacyPolicy: 'Gizlilik Politikası',
      apiDocumentation: 'API Dokümantasyonu',
      termsAndConditions: 'Şartlar & Koşullar',
      helixProvides:
        'Not: Helix, Injective DAO tarafından onaylanan birçok piyasada yapıcı iadeleri sağlamaktadır.'
    },
    tradingBots: {
      all: 'Tümü',
      time: 'Zaman',
      user: 'Kullanıcı',
      auto: 'Otomatik',
      lower: 'Alt',
      upper: 'Üst',
      active: 'Aktif',
      manual: 'Manuel',
      endBot: 'Botu Durdur',
      removed: 'Kaldırıldı',
      pending: 'Beklemede',
      overview: 'Genel Bakış',
      showcase: 'Vitrin',
      duration: 'Süre',
      spotGrid: 'Spot Grid',
      totalTvl: 'Toplam TVL',
      totalPnl: 'Toplam PnL',
      totalRoi: 'Toplam ROI',
      moreInfo: 'Daha Fazla Bilgi',
      gridMode: 'Izgara Modu',
      title: 'Daha Akıllı Ticaret',
      available: 'Mevcut',
      geometric: 'Geometrik',
      startTime: 'Başlangıç Zamanı',
      gridBound: 'Izgara Sınırı',
      investment: 'Yatırım',
      priceRange: 'Fiyat Aralığı',
      activeBots: 'Aktif Botlar',
      lowerPrice: 'Alt Fiyat',
      upperPrice: 'Üst Fiyat',
      lowerBound: 'Alt Sınır',
      upperBound: 'Üst Sınır',
      gridNumber: 'Izgara Sayısı',
      stopReason: 'Durdurma Nedeni',
      futuresGrid: 'Vadeli Grid',
      totalProfit: 'Toplam Kar',
      volumeBoost: 'Hacim Artışı',
      totalAmount: 'Toplam Tutar',
      totalAssets: 'Toplam Varlıklar',
      viewDetails: 'Detayları Görüntüle',
      profitGrid: 'Izgara Aralığı',
      gridDetails: 'Izgara Detayları',
      assetsInBot: 'Bottaki Varlıklar',
      currentPrice: 'Mevcut Fiyat',
      copyStrategy: 'Stratejiyi Kopyala',
      noActiveBots: 'Aktif Bot Yok',
      enableLpMode: 'LP Modunu Etkinleştir',
      trailingBound: 'Takip Eden Sınır',
      setUpNewBot: 'Yeni Bot Kur',
      liquidityGrid: 'Likidite Grid',
      topPerformers: 'En İyi Performans Gösterenler',
      initialAmount: 'Başlangıç Miktarı',
      numberOfGrids: 'Izgara Sayısı',
      createStrategy: 'Strateji Oluştur',
      enableTrailing: 'Takibi Etkinleştir',
      learnMoreHere: 'Buradan daha fazla bilgi edinin.',
      removeStrategy: 'Stratejiyi Kaldır',
      lowerPriceStop: 'Alt Fiyat Durdurma',
      upperPriceStop: 'Üst Fiyat Durdurma',
      saveOnFees: 'Para Yatırma Miktarlarını Ayarla',
      noStrategies: 'Strateji Bulunamadı.',
      optimizedAmounts: 'Optimize Edilmiş Miktarlar',
      totalBotsCreated: 'Toplam Oluşturulan Botlar',
      replicateStrategy: 'Stratejiyi Kopyala',
      buySymbolOnStop: '{symbol} durduğunda satın al',
      insufficientFunds: 'Yetersiz Bakiye',
      approximateProfit: 'Tahmini Kar',
      initialEntryPrice: 'Başlangıç Giriş Fiyatı',
      trailingPriceRange: 'Takip Eden Fiyat Aralığı',
      createYourStrategy: 'Stratejinizi Oluşturun',
      noActiveStrategies: 'Aktif Strateji Yok',
      keepOriginalAmounts: 'Orijinal Miktarları Koru',
      useFeeOptimizedAmounts: 'Önerilen Miktarları Kullan',
      sellAllSymbolOnStop: 'Tüm {symbol} durduğunda sat',
      exceededMaxRetries: 'Dalgalı Piyasa Koşulları',
      copyParametersToManual: 'Parametreleri Manüele Kopyala',
      botCreationConfirmation: 'Bot Oluşturma Onayı',
      strategyRemovalInitiated: 'Strateji Kaldırma Başlatıldı',
      sellSymbolUponTermination: 'Sonlandırıldığında {symbol} sat',
      marketConditionsNotSupported: 'Piyasa koşulları desteklenmiyor',
      minInvestmentDescription: "Minimum Yatırım: {symbols} ≥ {'$'}{amount}",
      youCanCloseThisNotification:
        'Bu bildirimi kapatabilir ve platformu kullanmaya devam edebilirsiniz.',
      confirmationDescription:
        'Lütfen ilerlemek için aşağıdaki bilgileri dikkatlice okuyup onaylayın.',
      autoModeHeader:
        'Bu parametreler son 30 günlük işlem fiyatlarına göre otomatik oluşturulmuştur.',
      nOfGridsTooltip:
        'Daha yüksek ızgara sayısı, fiyat hareketlerini daha iyi yakalamak için daha fazla emir verir ancak daha fazla başlangıç sermayesi gerektirir.',
      yourTradingStrategyIsBeingRemoved:
        'Ticaret stratejiniz kaldırılıyor ve otomatik olarak tamamlanacak. Bu işlem birkaç dakika sürebilir.',
      disclaimer:
        'Risk Uyarısını okudum ve anladım, parametre seçimi ve yatırım kararının her durumda yalnızca müşteri tarafından verileceğini kabul ediyorum.',
      description:
        "Helix'te otomatik ticaret için komut merkeziniz. Aktif botlarınızı izleyin, LP ödüllerinizi takip edin ve topluluk tarafından başarılı bulunan stratejileri keşfedin.",
      topPerformersDescription:
        "Gerçek zamanlı başarıdan öğrenin. Hangi stratejiler ve parametrelerin Helix'te şu anda en iyi sonuçları verdiğini görün. Bu verileri yaklaşımınızı geliştirmek veya kanıtlanmış performansa dayalı yeni bir bot başlatmak için kullanın.",
      botType: {
        spotGrid: 'Spot Grid',
        futuresGrid: 'Vadeli Grid',
        liquidityGrid: 'Hacim Artışı'
      },
      myLpRewards: {
        viewAll: 'Tümünü Görüntüle',
        title: 'LP Ödüllerim',
        volumeAllTime: 'Toplam Hacim',
        rewardsAllTime: 'Toplam LP Ödülleri',
        volumeThisRound: 'Bu Turdaki Hacim',
        totalEstRewards: 'Toplam Tahmini Ödüller',
        roundEndTime: '{round} Numaralı Turun Bitiş Zamanı'
      },
      sgt: {
        lpModeTooltip:
          'LP Modu etkinleştirildiğinde, strateji kurulum sırasında yeniden dengelemeden kaçınır ve likidite sağlayıcının davranışını taklit ederek asimetrik alım ve satım emirleri oluşturur.',
        lowerPriceStopTooltip:
          "Izgaranın yeni alım emirleri oluşturmayı durduracağı alt fiyatı tanımlayın. Bu, pozisyonunuzu kapatan geleneksel bir 'stop loss' değildir, ancak istediğiniz ızgara aralığı dışındaki alım faaliyetini duraklatma koşuludur.",
        upperPriceStopTooltip:
          'Izgaranın yeni satım emirleri oluşturmayı durduracağı üst fiyatı belirleyin. Bu, aktif ızgara satışları için bir tavan görevi görür ve fiyat tanımladığınız aralığı aştığında faaliyeti duraklatır.',
        minInvestmentTooltip:
          "Minimum Yatırım: {'$'}{amount}’dan başlar. 10 ızgaradan sonra her ızgara için 5$ eklenir, en fazla 100 ızgara için. Miktar, {assets} varlıklarının dolar değerine göre hesaplanır.",
        balancedFeesMessage:
          "Yatırımınızın değeri {initialInvestment} USD'dir. Verilen fiyat aralığı ve ızgara sayısına dayanarak, her varlık için önerilen miktar {quoteAmount} {quote} ve {baseAmount} {base}’dır. Önerilen yatırım miktarları, botun başlangıçta oluşturacağı alım ve satım emirlerine dayanır ve sağladığınız orijinal yatırım miktarları ile aynı değeri korur.",
        investmentTooltip:
          'USDT & INJ karışımı ile dengeleme stratejisi ücretlerini azaltın. Bu yeni bir platform ücreti değil, strateji oluştururken quote ve base denomları arasında dönüştürme sırasında gaz maliyetlerini azaltmanın bir yoludur.',
        gridModeTooltip:
          'Aritmetik modda, iki ardışık ızgara arasındaki fiyat sabit bir farktır. Geometrik modda ise, iki ardışık ızgara arasındaki fiyat sabit bir orandır.',
        tabs: {
          liveSpotGrid: 'Canlı Spot Grid',
          spotGridHistory: 'Spot Izgara Geçmişi',
          liveFuturesGrid: 'Canlı Vadeli Grid',
          futuresGridHistory: 'Vadeli Izgara Geçmişi'
        },
        modes: {
          perpetual: 'Sürekli',
          geometric: 'Geometrik',
          arithmetic: 'Aritmetik',
          arithmetic_lp: 'Aritmetik LP',
          trailing_arithmetic: 'Takip Eden Aritmetik',
          trailing_arithmetic_lp: 'Takip Eden Aritmetik LP'
        },
        optimization: {
          optimizeBalance: 'Dengeyi Optimize Et',
          balanceOptimized: 'Optimal Denge',
          balanceStability: 'Denge İstikrarı',
          confirmAndAdjust: 'Onayla ve Ayarla',
          balanceNeedsAdjusting: 'Dengenin Ayarlanması Gerekir',
          optimizeBalanceTitle: 'Strateji Dengesini Optimize Et',
          adjustYourAvailableBalance:
            'Kullanılabilir [{base}] ve [{quote}] bakiyenizi ayarlayın',
          yourBalanceIsOptimal:
            'Fiyat aralığında maksimum ızgara verimliliği için iyi dengelenmiş',
          yourBalanceIsOffBy:
            'Dengeniz optimal 50/50 oranından {percentage}% sapmıştır.',
          balancedTooltip:
            'Denge İstikrarı, likidite pozisyonunuzun tokenlar arasındaki amaçlanan oranı ne kadar iyi koruduğunu gösterir. Daha yüksek bir yüzde, pozisyonunuzun piyasa dalgalanmalarına karşı daha dirençli olduğu ve daha az sık yeniden dengeleme gerektirdiği anlamına gelir.',
          optimizeBalanceBody:
            'İşlem ücretlerini azaltmak ve operasyonel verimliliği artırmak için varlıklarınızı yeniden dengelemenizi öneririz. Bu teknik ayar, stratejinizin işlemleri nasıl gerçekleştirdiğini optimize eder, ancak varlık seçimi veya beklenen getiriler hakkında finansal tavsiye değildir.'
        }
      },
      liquidityBots: {
        title: 'Hacim Artışı Botu',
        description:
          'Ticaret hacmini zahmetsizce artırın. Hacim Artışı Botu, belirtilen aralığınız içinde işlem yaparak fırsatları yakalar ve piyasa varlığını korur.',
        deposit: 'Yatır',
        passive: 'Pasif',
        moderate: 'Orta',
        duration: 'Süre',
        createBot: 'Bot Oluştur',
        aggressive: 'Agresif',
        selectPair: 'Çift Seç',
        timeCreated: 'Oluşturulma Zamanı',
        finalBalance: 'Nihai Bakiye',
        depositAmount: 'Yatırılan Miktar',
        trailingUpper: 'Takip Eden Üst',
        trailingLower: 'Takip Eden Alt',
        currentBalance: 'Mevcut Bakiye',
        setLiquidityBot: 'Likidite Botu Kur',
        volatilityStrategy: 'Volatilite Stratejisi',
        trailingBoundaries: 'Takip Eden Sınırlar',
        upToRewards: 'Haftalık {amount} {symbol} ödüllerine kadar',
        depositDescription: 'Tek bir varlık ile likidite ekleyebilirsiniz'
      }
    },
    leaderboard: {
      myStats: 'İstatistiklerim',
      title: 'Liderlik Tablosu',
      viewMore: 'Daha Fazla Gör',
      helix: 'helixapp.com',
      timestamp: 'Zaman Damgası',
      startTrading: 'Ticarete Başla',
      privacyPolicy: 'Gizlilik Politikası',
      rulesTermsAndConditions: 'Kurallar, Şartlar ve Koşullar',
      refresh: 'Liderlik tablosu her saat başında yenilenir',
      description:
        "Helix, en iyi Trader’ları zincir üstü ticaret'lerine göre sıralar",
      tradeAndWin:
        'Henüz liderlik tablosunda değil misin? Kazanan işlemler yaparak yerini al!',
      blocked:
        'ABD, Birleşik Krallık ve resmi {terms} yarışma ülkeleri listesindeki bazı ülkelerin sakinleri yarışmaya katılamaz veya kazanamaz.',
      tabs: {
        leaderboard: 'PnL Liderlik Tablosu',
        'leaderboard-competition': 'Ticaret Yarışması',
        'leaderboard-past-competitions': 'Geçmiş Yarışmalar'
      },
      pnl: {
        share: 'Paylaş',
        tradingPnl: 'Ticaret PnL',
        noPnlData: 'PnL sonucu bulunamadı',
        allTime: '1 Ağustos 2024 00:00 UTC’den beri',
        currentDuration: 'Ticaret PnL ({duration})',
        lastUpdated: 'Son Güncelleme: {lastUpdatedDate}',
        timePeriod: 'Zaman Aralığı: {startDate} - {endDate}',
        duration: {
          '1D': 'Bugün',
          ALL: 'Tüm Zamanlar',
          '1W': 'Bu Hafta',
          '1M': 'Bu Ay'
        }
      },
      competition: {
        winner: 'Kazanan',
        unranked: 'Sıralanmamış',
        currentLeaderFlame: '🔥',
        keepGoing: 'Devam et 💪',
        tradingVolume: 'Ticaret Hacmi',
        currentLeader: 'Mevcut lider',
        competitionDuration: 'Kalan Süre: {duration}',
        noVolumeData: 'Ticaret yarışması sonucu bulunamadı',
        rulesTermsAndConditionsApply:
          'Kurallar, Şartlar ve Koşullar Geçerlidir',
        checkBackLater:
          'Kazandınız mı görmek için daha sonra tekrar kontrol edin!',
        competitionBeginning: 'Yarışma başlamak üzere...',
        noPastCompetition: 'Şu anda geçmiş yarışma yok.',
        thanksForParticipating:
          'Katıldığınız için teşekkürler! Maalesef bu sefer kazanamadınız.',
        noCompetition:
          'Şu anda aktif yarışma yok, lütfen daha sonra tekrar kontrol edin!',
        firstHourOfCampaign:
          'Yarışma şimdi başladı. Liderlik tablosu kampanya istatistiklerini {afterFirstHour} itibarıyla göstermeye başlayacak.',
        additionalEntriesTooltip:
          'Bu girişler, yarışma sırasında bir veya daha fazla bonus döneme katılarak kazanılan bonus girişlerdir.',
        winnerModal: {
          emailPlaceholder: 'E-posta adresiniz',
          namePlaceholder: 'Adınız ve soyadınız',
          bannerDescription:
            'Tebrikler! Liderlik tablosu yarışmamızın kazananlarından birisiniz. Bu sefer {prize} kazandınız. Ödülünüzü talep etmeye başlamak için tıklayın!',
          getStarted: {
            cta: 'Başlayın',
            title: 'Tebrikler!',
            description:
              '{competition} yarışmasının kazananlarından birisiniz! {prize} talep etmek için lütfen ek bilgileri sağlayın.'
          },
          contactInfo: {
            cta: 'Onayla',
            title: 'İletişim Bilgileri Gerekiyor',
            description:
              'Yarışmanın Resmi {terms} kurallarına uymak için, doğrulama ve ödül teslimatı amacıyla lütfen iletişim bilgilerinizi sağlayın. Ayrıca, lütfen aşağıya tıklayarak {privacyPolicy}’yi inceleyip kabul ettiğinizi onaylayın.'
          }
        }
      },
      header: {
        rank: 'Sıra',
        entries: 'Girişler',
        address: 'Adres',
        weeklyROI: 'Haftalık Getiri',
        volume: 'İşlem Hacmi (USD)',
        tradingPnl: 'Ticaret Kar/Zarar (USD)',
        numberOfEntries: 'Giriş Sayısı',
        allMarketsVolume: 'Tüm Piyasalar İşlem Hacmi (USD)'
      },
      footer: {
        onlyTop100Connect:
          'İstatistiklerinizi görmek için cüzdanınızı bağlayın.',
        onlyTop100: 'Liderlik tablosu en fazla ilk 100 katılımcıyı gösterir.'
      }
    },
    maintenance: {
      title: 'Planlı Bakım',
      governance: 'Yönetim Önerisi',
      subscribe: 'Bildirimlere Abone Ol',
      subscribeDescription: 'Notifi ile gerçek zamanlı bildirimler alın',
      governanceDescription: 'En son zincir güncellemesini kontrol edin',
      footer:
        "Helix'i daha iyi yapmak için çalışıyoruz. Sabır gösterdiğiniz için teşekkür ederiz, yakında geri döneceğiz!",
      description:
        'Birkaç güncelleme yapıyoruz. Bu süre zarfında bazı özellikler bir süre kullanılamayacak.'
    },
    feeDiscounts: {
      off: 'Kapalı',
      tier: 'Seviye',
      maker: 'Maker',
      taker: 'Taker',
      myFeeTier: 'Benim Ücret Seviyem',
      currentApr: 'Mevcut APR',
      pageTitle: 'Ücret İndirimleri',
      updateDaily: 'Günlük güncelle',
      stakedAmount: 'Staked Miktar',
      tradingVolume: 'İşlem Hacmi',
      myStakedAmount: 'Staked Miktarım',
      lastUpdatedAt: 'Son güncelleme zamanı',
      inPastDays: 'Son {days} gündeki',
      myTradingVolume: 'Benim İşlem Hacmim',
      viewFeeDiscounts: 'Ücret İndirimlerini Görüntüle',
      feesTakerMaker: 'Ücretler (Taker / Maker)',
      makerRateDiscount: 'Maker Oranı İndirimi',
      takerRateDiscount: 'Taker Oranı İndirimi',
      feesTakerMakerPercent: '{takerFee}% / {makerFee}%',
      makerRateDiscountTooltip: 'Ücret seviyesine göre maker ücret indirimi.',
      takerRateDiscountTooltip: 'Ücret seviyesine göre taker ücret indirimi.',
      pageDescriptionWarning:
        'Maker ücret indirimlerinin sadece negatif olmayan maker ücretlerine sahip piyasalarda geçerli olduğunu unutmayın.',
      pageDescription:
        'Ticaret ücretleri, kullanıcının stake ettiği INJ miktarı ve son 28 gündeki toplam işlem hacmine dayanır.',
      tradingVolumeTooltip:
        '28 günlük hareketli bazda işlem gören toplam hacim. Şu anda sadece USD bazlı piyasalar dahildir.',
      stakedAmountTooltip:
        'Stake edilmesi gereken INJ miktarı. INJ stake etmek protokolü güvenceye alır, ödüller kazandırır ve daha uygun ücret seviyesi elde etmeye yardımcı olabilir.'
    },
    tradeAndEarn: {
      title: 'Ticaret & Kazan',
      description:
        'Spot ve Perpetual işlem sayfalarında ya da trading bot kullanarak INJ kazanın',
      pts: 'puan',
      stakeMore: 'Daha fazla stake et',
      makerPoints: 'maker puanı',
      takerPoints: 'taker puanı',
      estRewards: 'Tahmini Ödüller',
      campaignAsOf: '{date} itibariyle',
      estRewardsStake: 'Tahmini Ödüller',
      pendingRewards: 'Bekleyen Ödüller',
      emptyPendingRewards: 'Bekleyen ödül yok.',
      pendingMaxCampaignRewards: 'Toplam tahsis edilen ödüller',
      myRewardPoints: 'Benim Ödül Puanlarım / Toplam Ödül Puanları',
      stakeTotalToReceiveFullAmount:
        'Tam miktarı almak için toplam {total} INJ stake edin',
      sunset:
        'Trade & Earn programına katıldığınız için teşekkürler! Helix kullanıcılarını ödüllendirecek yeni programlar için takipte kalın.',
      pendingMaxCampaignRewardsTooltip:
        "Önceki epoch'ta dağıtılan toplam INJ miktarı. Ödül dağıtımı vesting dönemi sonunda gerçekleşir.",
      myRewardPointsTooltip:
        'Bu kampanya süresince kazandığınız mevcut ödül puanları ve kampanyadaki toplam ödül puanları. Ödül puanları yeni kampanya başında sıfırlanır.',
      estRewardsStakeTooltip:
        'Bu adrese dağıtılacak tahmini ödül, ödül puanlarınız / toplam ödül puanları * toplam tahsis edilen ödül bazında hesaplanır. Bu, ödül puanlarınızın kampanya sonuna kadar toplam ödül puanlarıyla aynı hızda artacağı varsayılarak hesaplanır. Ödülünüzü korumak veya artırmak için kampanya sonuna kadar aynı veya daha yüksek işlem aktivitesini sürdürmelisiniz. Ödül miktarı {maxRewards} INJ veya stake edilen INJ miktarının eşdeğeri ile sınırlıdır.'
    },
    institutional: {
      benefits: 'Avantajlar',
      talkToUs: 'Bizimle konuşun.',
      modalTitle: 'İletişime Geçin',
      getInTouch: 'İletişime geçin',
      learnMore: 'Daha fazlasını öğrenmeye hazır mısınız?',
      trustedByTheBest: 'En iyiler tarafından tercih ediliyor',
      heroTitle: 'Gerçekten Zincir Üzerinde Kurumsal Finans',
      allRightsReserved: 'Injective Labs. Tüm Hakları Saklıdır.',
      modalDescription: 'Helix Kurumsal ekibiyle doğrudan bağlantı kurun.',
      whyFinancialInstitutionsChooseHelix:
        "Finansal kurumların Helix'i tercih etme sebepleri",
      heroSubtitle:
        'Sınırsız kripto varlıklar, perpetual sözleşmeler ve yapılandırılmış ürünlerle tek tam merkeziyetsiz ağda işlem yapın.',
      permisionedMarketsTitle: 'İzinli Piyasalar',
      permisionedMarketsBody:
        'Helix, kurumsal seviyede izinli piyasalara eşsiz bir geçit sunar, profesyonelce incelenmiş karşı taraflarla sorunsuz etkileşim sağlar.',
      multiAssetSupportTitle: 'Çoklu Varlık Desteği',
      multiAssetSupportBody:
        'Birden fazla blok zinciri ağı üzerinde zincir üzerinde varlıklar, türevler ve yapılandırılmış ürünlere erişim sağlayın.',
      onChainTransparencyTitle: 'Zincir Üzeri Şeffaflık',
      onChainTransparencyBody:
        'Tüm işlemlerin, ticaretlerin, mutabakatların ve varlık ihraçlarının tamamen zincir üzerinde gerçekleştiği tek platformla güvenliğinizi maksimize edin.',
      fullyCompliantTitle: 'Tam Uyumluluk',
      fullyCompliantBody:
        'Tüm işlemlerin, ticaretlerin, mutabakatların ve varlık ihraçlarının tamamen zincir üzerinde gerçekleştiği tek platformla güvenliğinizi maksimize edin.',
      instantSettlementTitle: 'Anında Mutabakat',
      instantSettlementBody:
        'Manipülasyona karşı dayanıklı MEV dirençli işlemler gerçekleştirin; sektördeki en hızlı mutabakat süreleriyle.',
      robustSecurityTitle: 'Güçlü Güvenlik',
      robustSecurityBody:
        'Varlıklarınızın kontrolünüzden hiç çıkmamasını sağlayan en sıkı güvenlik önlemleriyle teminatlı, emanetsiz bir platform kullanın.',
      superiorInfrastructureTitle: 'Üstün Altyapı',
      superiorInfrastructureBody:
        'En sofistike finans kurumları ve traderların ihtiyaçlarına uygun Helix’in özel altyapısından faydalanın.',
      form: {
        email: 'E-posta',
        company: 'Şirket',
        lastName: 'Soyadı',
        firstName: 'Adı'
      }
    },
    common: {
      or: 'veya',
      and: 've',
      pnl: 'Kar/Zarar',
      max: 'Maks',
      docs: 'dokümanlar',
      back: 'Geri',
      base: 'Temel',
      blog: 'blog',
      ended: 'Sona Erdi',
      copy: 'Kopyala',
      here: 'burada',
      link: 'bağlantı',
      view: 'Görüntüle',
      total: 'Toplam',
      quote: 'Teklif',
      value: 'Değer',
      close: 'Kapat',
      ready: 'Hazır',
      claim: 'Talep Et',
      amount: 'Miktar',
      enable: 'Etkinleştir',
      submit: 'Gönder',
      search: 'Ara',
      cancel: 'İptal',
      sortBy: 'Sırala',
      connect: 'Bağlan',
      details: 'Detaylar',
      runtime: 'Çalışma Süresi',
      claimed: 'Talep Edildi',
      deposit: 'Para Yatır',
      confirm: 'Onayla',
      disabled: 'Devre Dışı',
      inactive: 'pasif',
      transfer: 'Transfer Et',
      withdraw: 'Çek',
      tradeNow: 'Şimdi Al-Sat',
      active: 'Aktif',
      noItems: 'Öğe Yok',
      download: 'İndir',
      ascending: 'Artan',
      learnMore: 'Daha fazla bilgi',
      descending: 'Azalan',
      tradingDocs: 'Ticaret Dokümanları',
      unauthorized: 'Yetkisiz',
      baseAndQuote: 'Temel ve Teklif',
      sortDirection: 'Sıralama Yönü',
      dontShowAgain: 'Bir daha gösterme',
      showMoreContext: 'Daha fazla bağlam göster',
      acknowledgeTerms: 'Şartları kabul et',
      pagination: '{from} ile {to} arası, toplam {totalCount}',
      day: 'Gün',
      hour: 'Saat',
      minute: 'Dakika',
      second: 'Saniye',
      account: {
        main: 'Ana',
        subaccount: 'Alt Hesap',
        mainSubaccount: 'Ana Alt Hesap',
        subaccountId: 'Alt Hesap {subaccountId}',
        subaccountTransfer: 'Alt Hesap Transferi',
        noAssetToTransfer: 'Bu alt hesaptan transfer edilecek varlığınız yok.'
      },
      modal: {
        terms: {
          privacyPolicy: 'Gizlilik Politikası',
          termsAndCondition: 'Şartlar ve Koşullar',
          title:
            'Ayrıca, aşağıdaki hususları beyan, garanti ve kabul edersiniz:',
          acknowledge_1:
            "ABD (perpetual sözleşme ticareti açısından), İngiltere (yatırım profesyoneli değilseniz) veya Helix Şartlar ve Koşullarında tanımlanan Kısıtlı Bölge'de ikamet eden, bulunan, kayıtlı acentesi olan kişi veya şirket değilsiniz.",
          acknowledge_2:
            "Şu anda veya gelecekte ABD (perpetual sözleşme ticareti açısından), İngiltere (yatırım profesyoneli değilseniz) veya Kısıtlı Bölge'de bulunurken bu siteye veya helixapp.com’a erişmeyeceksiniz veya kullanmayacaksınız.",
          acknowledge_3:
            'Kısıtlı Bölge’de fiziksel konumunuzu gizlemek için sanal özel ağ veya başka araçlar kullanmıyorsunuz ve kullanmayacaksınız.',
          acknowledge_4:
            'İkamet ettiğiniz ve bulunduğunuz yargı alanının yasaları kapsamında bu siteye erişme ve helixapp.com üzerinde işlem yapma hakkınız yasal olarak vardır.',
          acknowledge_5:
            'Kaldıraç kullanmanın, perpetual sözleşmelere girmemenin ve dijital varlıklarda işlem yapmanın risklerini anlıyorsunuz.',
          disclaimerNote:
            'Cüzdan bağlayarak, Helix {0} ve Injective Labs {1}’i okuduğunuzu, kabul ettiğinizi ve bağlı olduğunuzu onaylarsınız.'
        },
        postOnlyMode: {
          title: 'Sadece Emir Modu!',
          description:
            'Injective Volan ana ağ yükseltmesinden sonraki 2000 blok (~30 dakika) boyunca sadece limit emirleri verilebileceğini unutmayın.'
        },
        geoRestricted: {
          cta: 'Anladım',
          title: 'Helix bölgenizde kullanılamıyor.',
          description:
            "Düzenleyici gereksinimler nedeniyle Helix'i bölgenizde sunamıyoruz. Ekibimiz hizmet alanımızı genişletmek ve yerel yasalara tam uyumu sağlamak için aktif olarak çalışıyor. İlginiz için teşekkür eder, büyüyen küresel topluluğumuza yakında katılmanızı umut ederiz. Açık pozisyonlarınız varsa portföy sayfasından kapatabilirsiniz."
        },
        devMode: {
          connect: 'Bağlan',
          enterPrivateKey: 'Özel anahtarınızı girin',
          connectWithPrivateKey: 'Özel anahtar ile bağlan',
          enterInjectiveAddress: 'Injective adresinizi girin'
        },
        ninjaPass: {
          later: 'Daha sonra',
          verifyNow: 'Şimdi doğrula',
          congratulations: 'Tebrikler! 🎉',
          title: 'Özel Ninja Pass kazandınız 🥷',
          description:
            'Bu, size özel Injective etkinliklerine, ürünlerine, çekilişlere ve daha birçok sürprize giriş kapınız olacak.'
        },
        onboarding: {
          buyInjWithCard: 'Kart ile INJ satın al',
          injectiveBridge: 'Injective Köprüsü',
          processing: 'Transferiniz işleniyor',
          closeAndContinue: 'Kapat ve devam et',
          success: 'İşleminiz onaylandı',
          depositUsdtFromEthereum: "Ethereum'dan USDT yatırın",
          processingMessage:
            'İşlem beklenenden uzun sürüyor. Lütfen biraz bekleyin.',
          processingMessageInfo:
            'Transferiniz arka planda işleniyor, bu modalı güvenle kapatabilirsiniz. Köprülenen miktarı bakiye sayfasında veya köprü geçmişinizi görüntüleyerek kontrol edebilirsiniz.'
        }
      }
    },
    notFound404: {
      title: 'Sayfa Bulunamadı',
      backToHome: 'Ana sayfaya dön',
      description: 'Aradığınız sayfa mevcut değil.'
    }
  }
})
